import cx from "classnames";

type TextAreaProps = {
  label: string;
  name?: string;
  value?: string;
  disabled?: boolean;
  invalid?: boolean;
  supportingText?: string;
  rows?: number;
  maxLength?: number;
  onChange?: (value: string) => void;
  "data-testid"?: string;
  readOnly?: boolean;
  autoFocus?: boolean;
  visible?: boolean;
  placeholder?: string;
};

export const TextArea = ({
  autoFocus = false,
  name,
  disabled,
  label,
  value,
  invalid,
  supportingText,
  rows = 4,
  maxLength,
  onChange,
  visible,
  readOnly,
  "data-testid": dataTestId,
  placeholder,
}: TextAreaProps) => {
  return (
    <label
      className={cx(
        "relative block pt-2",
        (disabled || readOnly) && "opacity-60"
      )}
    >
      <textarea
        aria-invalid={invalid}
        placeholder={placeholder || " "}
        autoFocus={autoFocus}
        className="-ring-offset-1 peer mb-1 block w-full appearance-none rounded border-none text-primary ring-1 ring-light-grey [color-scheme:light] placeholder:!text-transparent focus:outline-none focus:ring-1 focus:ring-black focus:placeholder:!text-secondary aria-invalid:ring-1 aria-invalid:ring-red aria-invalid:placeholder:text-red"
        cols={40}
        data-testid={dataTestId}
        disabled={disabled}
        maxLength={maxLength}
        name={name}
        readOnly={readOnly}
        rows={rows}
        aria-hidden={!visible}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
      />
      <span className="absolute left-3 top-0 whitespace-nowrap bg-white px-1 text-xs text-secondary peer-placeholder-shown:invisible peer-focus:!visible peer-focus:text-black peer-aria-invalid:text-red">
        {label}
      </span>
      <span
        className={cx(
          "absolute left-3 top-5 cursor-text bg-white px-1 text-body1 text-secondary peer-focus:!invisible peer-aria-invalid:text-red",
          value && "hidden"
        )}
      >
        {label}
      </span>
      {supportingText && (
        <span className="px-4 text-body3 text-secondary peer-aria-invalid:text-red">
          {supportingText}
        </span>
      )}
    </label>
  );
};
